import { useEffect } from 'react';

import {
    getCurrentUserEmail,
    loadProfile,
    PROFILE_UPDATED_EVENT,
} from '../utils/profileStorage';
import {
    buildFavoriteDealNotificationKey,
    findFavoriteDealMatches,
} from '../utils/favoriteDeals';
import api_url from '../config/api_url';

const NOTIFICATION_STORAGE_PREFIX = 'budgetvenlig.favorite-deal-notification.v1';

function FavoriteDealNotifier() {
    useEffect(() => {
        let requestId = 0;

        const checkFavoriteDeals = async () => {
            const currentRequestId = requestId + 1;
            requestId = currentRequestId;
            const email = getCurrentUserEmail();
            const profile = loadProfile(email);

            if (
                !email
                || !profile.favoriteDealAlertsEnabled
                || !profile.browserDealNotificationsEnabled
                || profile.favoriteRecipes.length === 0
                || typeof window.Notification === 'undefined'
                || window.Notification.permission !== 'granted'
            ) {
                return;
            }

            try {
                const response = await fetch(api_url + 'api/recommendations/weekly');
                if (!response.ok) {
                    return;
                }
                const weeklyData = await response.json();
                if (currentRequestId !== requestId) {
                    return;
                }

                const matches = findFavoriteDealMatches(weeklyData, profile);
                if (matches.length === 0) {
                    return;
                }

                const notificationKey = buildFavoriteDealNotificationKey(weeklyData, profile, matches);
                const storageKey = `${NOTIFICATION_STORAGE_PREFIX}:${email}`;
                if (window.localStorage.getItem(storageKey) === notificationKey) {
                    return;
                }

                const offerCount = matches.reduce((total, match) => total + match.offers.length, 0);
                new window.Notification('Dine favoritretter er på tilbud', {
                    body: `${offerCount} ingrediens${offerCount === 1 ? '' : 'er'} matcher din grænse på ${profile.favoriteDealThreshold}%.`,
                    icon: '/favicon.ico',
                });
                window.localStorage.setItem(storageKey, notificationKey);
            } catch {
                // Deal alerts remain available in the profile if browser notifications fail.
            }
        };

        checkFavoriteDeals();
        window.addEventListener(PROFILE_UPDATED_EVENT, checkFavoriteDeals);
        window.addEventListener('focus', checkFavoriteDeals);

        return () => {
            requestId += 1;
            window.removeEventListener(PROFILE_UPDATED_EVENT, checkFavoriteDeals);
            window.removeEventListener('focus', checkFavoriteDeals);
        };
    }, []);

    return null;
}

export default FavoriteDealNotifier;
